import IProductDecription, * as Products from './ProductDecription'

export class ProductLinkRegistry {
  private static links: Record<string, string> = {

    'WH-TFKRFB': 'https://tech-controllers.hu/p/eu-r-8b-plus',
    'WH-TFKRF230B': 'https://tech-controllers.hu/p/eu-r-8pz-plus',
    'WH-TFKRFNB': 'https://tech-controllers.hu/p/eu-r-8s-plus',
    'WH-TFKRF230FB': 'https://tech-controllers.hu/p/eu-f-8z',
    'WH-TFKVNB': 'https://tech-controllers.hu/p/eu-r-12s',
    'WH-TFKVFB': 'https://tech-controllers.hu/p/eu-f-12b',
    'WH-TFKRF': 'https://tech-controllers.hu/p/eu-r-8b-plus',
    'WH-TFKRF230': 'https://tech-controllers.hu/p/eu-r-8pz-plus',
    'WH-TFKRFN': 'https://tech-controllers.hu/p/eu-r-8s-plus',
    'WH-TFKRF230F': 'https://tech-controllers.hu/p/eu-f-8z',
    'WH-TFKVN': 'https://tech-controllers.hu/p/eu-r-12s',
    'WH-TFKVF': 'https://tech-controllers.hu/p/eu-f-12b',
    'WH-TZV4B': 'https://tech-controllers.hu/p/eu-ml-4x-wifi',
    'WH-TZV4': 'https://tech-controllers.hu/p/eu-l-4x-wifi',
    'WH-TEMV': 'https://tech-controllers.hu/p/eu-505',
    'WH-TMFV2': 'https://tech-controllers.hu/p/i-3-plus',
    'WH-TMFV3': 'https://tech-controllers.hu/p/i-2-plus',
    'WH-TEMW': 'https://tech-controllers.hu/p/eu-wifi-rs',
    'WH-TMIX1': 'https://tech-controllers.hu/p/eu-i-1',
    'WH-TVV230': 'https://tech-controllers.hu/p/eu-mw-1-230v',
    'WH-TVV01': 'https://tech-controllers.hu/p/eu-mw-1',
    'WH-TVACT': 'https://tech-controllers.hu/p/stt-869',
    'WH-TMIX': 'https://tech-controllers.hu/p/eu-i-1m',

    'WH-EYMIX': 'https://www.pipelife.hu/content/dam/pipelife/hungary/let%C3%B6lt%C3%A9sek/szabalyozas/pro2-keveromodul-bekotesi-es-hasznalati-utmutato.pdf',
    'WH-DPLT-L': 'https://www.pipelife.hu/content/dam/pipelife/hungary/let%C3%B6lt%C3%A9sek/szabalyozas/PRO2%20-%20szobatermoszt%C3%A1t%20kezel%C3%A9si%20%C3%BAtmutat%C3%B3.pdf',
    'WH-EYMIX-L': 'https://www.pipelife.hu/content/dam/pipelife/hungary/let%C3%B6lt%C3%A9sek/szabalyozas/pro2-keveromodul-bekotesi-es-hasznalati-utmutato.pdf',
    'WH-1022-L': 'https://www.pipelife.hu/content/dam/pipelife/hungary/let%C3%B6lt%C3%A9sek/szabalyozas/PRO2%20-%20z%C3%B3navez%C3%A9rl%C5%91.pdf',

    'HM-RTLCD': 'https://www.pipelife.hu/content/dam/pipelife/hungary/let%C3%B6lt%C3%A9sek/szabalyozas/Floortherm%20P1%20szobatermoszt%C3%A1t.pdf',
    'HM-UH6': 'https://www.pipelife.hu/content/dam/pipelife/hungary/let%C3%B6lt%C3%A9sek/szabalyozas/Floortherm%20Hub6%20t%C3%B3navez%C3%A9rl%C5%91.pdf'
  };

  private static imgs: Record<string, string> = {

    'default-pic': '/Termostat/default.webp',
    'WH-TFKRFB': '/Termostat/WH-TFKRFB.webp',
    'WH-TFKRF230B': '/Termostat/WH-TFKRF230B.webp',
    'WH-TFKRFNB': '/Termostat/WH-TFKRFNB.webp',
    'WH-TFKRF230FB': '/Termostat/WH-TFKRF230FB.webp',
    'WH-TFKVNB': '/Termostat/WH-TFKVNB.webp',
    'WH-TFKVFB': '/Termostat/WH-TFKVFB.webp',
    'WH-TFKRF': '/Termostat/WH-TFKRF.webp',
    'WH-TFKRF230': '/Termostat/WH-TFKRF230.webp',
    'WH-TFKRFN': '/Termostat/WH-TFKRFN.webp',
    'WH-TFKRF230F': '/Termostat/WH-TFKRF230F.webp',
    'WH-TFKVN': '/Termostat/WH-TFKVN.webp',
    'WH-TFKVF': '/Termostat/WH-TFKVF.webp',
    'WH-TZV4B': '/Termostat/WH-TZV4B.webp',
    'WH-TZV4': '/Termostat/WH-TZV4.webp',
    'WH-TEMV': '/Termostat/WH-TEMV.webp',
    'WH-TMFV2': '/Termostat/WH-TMFV2.webp',
    'WH-TMFV3': '/Termostat/WH-TMFV3.webp',
    'WH-TEMW': '/Termostat/WH-TEMW.webp',
    'WH-TMIX1': '/Termostat/WH-TMIX1.webp',
    'WH-TVV230': '/Termostat/WH-TVV230.webp',
    'WH-TVV01': '/Termostat/WH-TVV01.webp',
    'WH-TVACT': '/Termostat/WH-TVACT.webp',
    'WH-TMIX': '/Termostat/WH-TMIX.webp',

    'WH-DPLT-L': '/Termostat/WH-DPLT-L.png',
    'WH-EYMIX-L': '/Termostat/WH-EYMIX-L.jpg',
    'WH-1022-L': '/Termostat/WH-1022-L.jpg',

    'HM-RTLCD': '/Termostat/HM-RTLCD.png',
    'HM-RTLCDWIFI': '/Termostat/HM-RTLCDWIFI.jpg',
    'HM-RTRFWIFI': '/Termostat/HM-RTRFWIFI.jpg'
  };

  private static Names: Record<string, string> = {

    'WH-TFKRFB': 'RF termosztát padló szenzor bemenettel fekete',
    'WH-TFKRF230B': 'RF termosztát 230V-os',
    'WH-TFKRFNB': 'RF termosztát nagy kijelzővel padló szenzor bemenettel 230V-os fekete',
    'WH-TFKRF230FB': 'RF termosztát fali kapcsolóba rejtett fekete',
    'WH-TFKVNB': 'Vezetékes termosztát nagy kijelzővel fekete',
    'WH-TFKVFB': 'Vezetékes termosztát fali kapcsolóba rejtett fekete',
    'WH-TFKRF': 'RF termosztát padló szenzor bemenettel',
    'WH-TFKRF230': 'RF termosztát 230V-os',
    'WH-TFKRFN': 'RF termosztát nagy kijelzővel padló szenzor bemenettel 230V-os',
    'WH-TFKRF230F': 'RF termosztát fali kapcsolóba rejtett',
    'WH-TFKVN': 'Vezetékes termosztát nagy kijelzővel',
    'WH-TFKVF': 'Vezetékes termosztát fali kapcsolóba rejtett',
    'WH-TZV4B': 'Vezeték nélküli és vezetékes 4 zónás vezérlő bővítő modul',
    'WH-TZV4': 'Vezeték nélküli és vezetékes 4 zónás vezérlő',
    'WH-TEMV': 'Vezetékes ethernet modul multifunkciós vezérlőhöz',
    'WH-TMFV2': 'Multifunkciós vezérlő 2 kevert kör',
    'WH-TMFV3': 'Multifunkciós vezérlő 3 kevert kör',
    'WH-TEMW': 'Wifis ethernet modul multifunkciós vezérlőhöz',
    'WH-TMIX1': 'Keverőszelep vezérlés modul',
    'WH-TVV230': 'Vezeték nélküli végrehajtó egység 230V',
    'WH-TVV01': 'Vezeték nélküli végrehajtó egység feszültségmentes jel',
    'WH-TVACT': 'Vezeték nélküli szelepmozgató',
    'WH-TMIX': 'Keverőszelep vezérlés kiegészítő modul (zóna vezérlőhöz)',
    'WH-TVR4': '4 pólusú váltó relé',
    'WH-TVR4A': '4 pólusú váltó relé aljzat',

    'WH-DPLT-L': 'Érintőgombos szobatermosztát',
    'WH-EYMIX-L': 'Keverőmodul hűtéshez és fűtéshez',
    'WH-1022-L': 'Zónavezérlő',
    'WH-TS-L': 'Vízőmérséklet szenzor',
    'WH-PS12V-L': '12V-os zápegység',
    'WH-V3GB': 'Háromjáratú rotációs keverőszelep mozgatómotorral',

    'HM-RTLCD': 'Vezetékes termosztát',
    'HM-UH6': '6 zónás zónavezérlő',
    'HM-RTLCDWIFI': 'Vezetékes termosztát wifi funkcióval',
    'HM-WIFIROUTER': 'Wifi router',
    'HM-RTRFWIFI': 'Vezeték nélküli termosztát wifi funkcióval',
    'HM-UH8RF': '8 zónás RF zónavezérlő'
  };

  private static ProductDescription: Record<string, IProductDecription> = {

    'HM-RTLCD': new Products.ProductDecriptionHMRTLCD(),
    'HM-RTLCDWIFI': new Products.ProductDecriptionHMRTLCDWIFI(),
    'HM-RTRFWIFI': new Products.ProductDecriptionHMRTRFWIFI(),
    'WH-DPLT-L': new Products.ProductDecriptionWHDPLTL(),
    'WH-TFKRF': new Products.ProductDecriptionWHTFKRF(),
    'WH-TFKRF230': new Products.ProductDecriptionWHTFKRF230(),
    'WH-TFKRF230F': new Products.ProductDecriptionWHTFKRF230F(),
    'WH-TFKRFN': new Products.ProductDecriptionWHTFKRFN(),
    'WH-TFKVF': new Products.ProductDecriptionWHTFKVF(),
    'WH-TFKVN': new Products.ProductDecriptionWHTFKVN(),
    'WH-TMFV2': new Products.ProductDecriptionWHTMFV2(),
    'WH-TMFV3': new Products.ProductDecriptionWHTMFV3(),
    'WH-TZV4': new Products.ProductDecriptionWHTZV4(),
    'WH-TZV4B': new Products.ProductDecriptionWHTZV4B(),
    'WH-TEMV': new Products.ProductDecriptionWHTEMV(),
    'WH-TEMW': new Products.ProductDecriptionWHTEMW(),
    'WH-TMIX': new Products.ProductDecriptionWHTMIX(),
    'WH-TMIX1': new Products.ProductDecriptionWHTMIX1(),
    'WH-TVACT': new Products.ProductDecriptionWHTVACT(),
    'WH-TVV01': new Products.ProductDecriptionWHTVV01(),
    'WH-TVV230': new Products.ProductDecriptionWHTVV230(),
    'WH-TFKRFB': new Products.ProductDecriptionWHTFKRFB(),
    'WH-TFKRF230B': new Products.ProductDecriptionWHTFKRF230B(),
    'WH-TFKRFNB': new Products.ProductDecriptionWHTFKRFNB(),
    'WH-TFKRF230FB': new Products.ProductDecriptionWHTFKRF230FB(),
    'WH-TFKVNB': new Products.ProductDecriptionWHTFKVNB(),
    'WH-TFKVFB': new Products.ProductDecriptionWHTFKVFB(),
    'WH-EYMIX-L': new Products.ProductDecriptionWHEYMIXL(),
    'WH-1022-L': new Products.ProductDecriptionWH1022L()
  }

  static getLink (productName: string): string | undefined {
    return this.links[productName] || undefined
  }

  static getImg (productName: string | undefined): string {
    return productName && this.imgs[productName] ? process.env.BASE_URL + this.imgs[productName] : ''
  }

  static getName (productName: string | undefined): string {
    return productName && this.Names[productName] ? this.Names[productName] : ''
  }

  static getProductDescription (productName: string | undefined): IProductDecription | null{
    return productName && this.ProductDescription[productName] ? this.ProductDescription[productName] : null
  }
}
